import { Languages } from "../LanguageContext";

const translations = {
  [Languages.English]: {
    verifyLevel: "Verify your level",
  },
  [Languages.German]: {
    verifyLevel: "Einstufung",
  },
};

export { translations };
